module.exports = __webpack_public_path__ + "img/join-bg (8).1ebe0168.jpg";